import { endpoints } from 'store/endpoints';
import { axiosInstance } from './axiosInstance';

export interface NewCommentRequestPayload {
  content: string;
  orderId?: string;
  userId?: string;
}
export class CommentsService {
  static async removeComment(id: string) {
    try {
      await axiosInstance.delete(endpoints.comments.opWithId(id));
    } catch (err: any) {
      throw new Error(err);
    }
  }
  static async createCommentAboutUser(payload: NewCommentRequestPayload) {
    try {
      const response = await axiosInstance.post(
        endpoints.comments.aboutUser,
        payload,
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }
  static async createComment(payload: NewCommentRequestPayload) {
    try {
      const response = await axiosInstance.post(
        endpoints.comments.general,
        payload,
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }

  static async updateComment(payload: string, id: string) {
    try {
      const response = await axiosInstance.patch(
        endpoints.comments.opWithId(id),
        {
          content: payload,
        },
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }
}
